module.exports = __webpack_public_path__ + "static/media/faico-360-flecha.592a6804.png";